var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "echarts-horizontal-bar-wrapper",
      style: { height: _vm.height + "px" },
    },
    [
      _c("v-chart", {
        ref: "chart",
        attrs: { options: _vm.chartOptions, autoresize: "" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }